






import { Component, Vue } from 'vue-property-decorator';
import { useAuth } from '@/oauth'; // Adjust path if needed
import { User } from '@auth0/auth0-spa-js';

@Component
export default class DapperAuthError extends Vue {
  async mounted() {
    const auth = useAuth(this);
    try {

      // debugging
      this.$nextTick(async () => {
        const user: User = await auth.getUser()
        console.dir(user, { depth: null })
        const accessToken: string = await auth.getTokenSilently()
        console.log(`accessToken: ${accessToken}`)
      })

    } catch (e) {
      console.error('Error:', e);
    }
  }
}
